export const studiesTypes = [
    { code: 'Título universitario de grado', label: 'Título universitario de grado' },
    { code: 'Tecnicatura', label: 'Tecnicatura' },
    { code: 'Especialización / Posgrado', label: 'Especialización / Posgrado' },
    { code: 'Maestría', label: 'Maestría' },
    { code: 'Doctorado', label: 'Doctorado' },
    { code: 'Diplomatura', label: 'Diplomatura' },
    { code: 'Certificación profesional', label: 'Certificación profesional' },
    { code: 'Curso / Taller', label: 'Curso / Taller' },
    { code: 'Formación complementaria', label: 'Formación complementaria' },
    { code: 'Otro', label: 'Otro' }
];

export const studiesStatus = [
    {code: 'in_progress', label: 'En proceso'},
    {code: 'finished', label: 'Culminado'},
    {code: 'frozen', label: 'Congelado'},
    {code: 'other', label: 'Otro'}
];